import Moment from "moment";
import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getAllPurchaseReturn = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "purchase_returns/get",
            {
                requester: getUser(),
                token: getToken(),
                receive_id: data.receive_id ? data.receive_id : "",
                invoice_no: data.invoice_no ? data.invoice_no : "",
                supplier_id: data.supplier_id ? data.supplier_id : "",
                purchase_return_id: data.id ? data.id : "",
                return_status: data.return_status ? data.return_status : "",
                status: data.status ? data.status : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                replacement_type: data.replacement_type ? data.replacement_type : "",
                page: data.page
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const getPurchaseReturn = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK+"purchase_returns/get", 
            {requester: getUser(), token: getToken(), purchase_return_id: id}
        )
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}

export const createPurchaseReturn = async (data, items, attachments) => {
    let formData = new FormData();
    formData.append('requester', getUser());
    formData.append('token', getToken());
    formData.append('receive_id', data.id);
    formData.append('type', data.type ? data.type : "");
    formData.append('branch_id', data.branch_id ? data.branch_id : "");
    // formData.append('branch_to', data.branch_to_id ? data.branch_to_id : "");
    formData.append('return_date', data.return_date ? data.return_date : "");
    formData.append('grand_total', data.grand_total ? data.grand_total : "");
    formData.append('status', data.status ? data.status : "");
    formData.append('receive_by_driver', data.receive_by_driver ? data.receive_by_driver : "");
    formData.append('receive_by_bodega', data.receive_by_bodega ? data.receive_by_bodega : "");
    
    items.map((item) => {
        formData.append(`receive_item_id[]`,item.id);
        formData.append(`item_id[]`,item.item_id);
        formData.append(`qty[]`,item.qty);
        formData.append(`inventory_qty[]`,item.inventory_qty);
        formData.append(`unit[]`,item.unit);
        formData.append(`price[]`,item.price);
        formData.append(`amount[]`, item.amount);
        formData.append(`serial_no[]`, item.serial_no ? item.serial_no : "");
        formData.append(`issue[]`, item.issue ? item.issue : "");
        formData.append(`reason[]`, item.reason ? item.reason : "");
    })

    attachments.forEach((file) => {
        formData.append(`attachments[]`, file, file.name);
    }); 

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_returns/create", formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updatePurchaseReturn = async (data, items, attachments) => {
        const formData = new FormData();     

        formData.append('requester', getUser());
        formData.append('token', getToken());
        formData.append('purchase_return_id', data.id);
        formData.append('receive_id', data.receive_id);
        formData.append('type', data.type ? data.type : "");
        formData.append('branch_id', data.branch_id ? data.branch_id : "");
        // formData.append('branch_to', data.branch_to_id ? data.branch_to_id : "");
        formData.append('return_date', data.return_date ? data.return_date : "");
        formData.append('grand_total', data.grand_total ? data.grand_total : "");
        formData.append('status', data.status ? data.status : "");
        formData.append('receive_by_driver', data.receive_by_driver ? data.receive_by_driver : "");
        formData.append('receive_by_bodega', data.receive_by_bodega ? data.receive_by_bodega : "");
        
        items.map((item) => {
            formData.append(`receive_item_id[]`,item.receive_item_id);
            formData.append(`purchase_return_item_id[]`,item.id);
            formData.append(`item_id[]`,item.item_id);
            formData.append(`qty[]`,item.qty);
            formData.append(`unit[]`,item.unit);
            formData.append(`price[]`,item.price);
            formData.append(`amount[]`, item.amount);
            formData.append(`serial_no[]`, item.serial_no ? item.serial_no : "");
            formData.append(`issue[]`, item.issue ? item.issue : "");
            formData.append(`reason[]`, item.reason ? item.reason : "");
        })

       
        attachments.map((file) => {
            formData.append('attachments[]', file, file.name);
            formData.append('attachment_ids[]', null);
        });
        data.prev_files.map((file) => {
            formData.append('attachment_ids[]', file.id);
        });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_returns/update", formData
        );
        return {data: response.data};
    } catch (error) {
        return { error: error.response };
    }
};

export const deletePurchaseReturn = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK+"/purchase_returns/delete",
             {requester: getUser(), token: getToken(), purchase_return_id: id}
        );
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}

// DEDUCT PAYMENT
export const updateReplacementType = async (id, type) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK+"/purchase_returns/update_replacement_type",
            {
                requester: getUser(), 
                token: getToken(), 
                purchase_return_id: id,
                replacement_type: type
            }
        );
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}

export const changePurchaseReturnStatus = async (id, status) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK+"/purchase_returns/change_status",
            {
                requester: getUser(), 
                token: getToken(), 
                purchase_return_id: id,
                status: status
            }
        );
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}